import React from 'react';
import './loadingStyle.css';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';

export const SimpleBackdrop = ({open}) => {
//   const [open, setOpen] = React.useState(false);
//   const handleClose = () => {
//     setOpen(false);
//   };
//   const handleToggle = () => {
//     setOpen(!open);
//   };

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
export const LoadingPage = (props) => {

    return (
        <>
        <div className="loadingPage" id={props.id} style={{display:"none"}}>
            <CircularProgress color="error" style={{marginTop:'25%'}}/>
        </div>
        </>
    )
}
